import { formatCount } from "../stages";
import type { Coverage } from "../types";
import { CoverageBar } from "./CoverageBar";

type Props = {
  coverage: Coverage | undefined;
  loading: boolean;
  error: boolean;
};

/** How many papers of the master list the maps have read. */
export const ReadingStage = ({ coverage, loading, error }: Props) => {
  if (error) {
    return (
      <p role="alert" className="text-sm text-zinc-600">
        Could not count the papers. The page tries again in 30 seconds.
      </p>
    );
  }
  if (!coverage) {
    return (
      <p className="text-sm text-zinc-500" aria-live="polite">
        {loading ? "Counting the papers…" : "The count starts when the dataset has the master list."}
      </p>
    );
  }
  const running = coverage.open_maps.length;
  return (
    <div className="space-y-3">
      <CoverageBar coverage={coverage} />
      <p className="text-xs text-zinc-600">
        {formatCount(coverage.maps)} {coverage.maps === 1 ? "map" : "maps"}
        {running > 0 && ` · ${running} running now`} · Updated every 30 seconds
      </p>
    </div>
  );
};
